import { Component, Input } from '@angular/core';
import { OmpHeadingSize, OmpNavPosition } from '../../../_models';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-welcome-message-settings',
  templateUrl: './welcome-message-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpWelcomeMessageSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  @Input() pageBackground = '';
  @Input() navPosition: OmpNavPosition = OmpNavPosition.Right;

  // Top nav puts the greeting in the nav bar, which owns its text size, colour and alignment.
  get headingInNav(): boolean {
    return this.navPosition === OmpNavPosition.Top;
  }
}
